((window)['__zone_symbol__PASSIVE_EVENTS'] = ['scroll'])